import React, { useState, useEffect } from 'react';
import { adminGetSettings, adminUpdateSettings } from '../../api/admin';
import AdminLayout from './AdminLayout';
import './AdminSettings.css'; 

const DEFAULTS = {
  site_name:          '',
  site_tagline:       '',
  site_phone:         '',
  site_email:         '',
  site_address:       '',
  whatsapp_number:    '',
  facebook_url:       '',
  instagram_url:      '',
  twitter_url:        '',
  youtube_url:        '',
  meta_title:         '',
  meta_description:   '',
  google_analytics:   '',
};

const SECTIONS = [
  {
    title: 'General',
    fields: [
      { key: 'site_name',    label: 'Site Name',    placeholder: 'Heaven Green Infra. Landscape' },
      { key: 'site_tagline', label: 'Tagline',      placeholder: 'One Step for Green World' },
      { key: 'site_phone',   label: 'Phone Number', placeholder: '+91 99812 06128' },
      { key: 'site_email',   label: 'Email',        placeholder: 'heavengreeninfra0@gmail.com', type: 'email' },
      { key: 'site_address', label: 'Address',      placeholder: 'Main Road Kathadih, Mathpurena, Raipur', textarea: true },
    ],
  },
  {
    title: 'Contact & WhatsApp',
    fields: [
      { key: 'whatsapp_number', label: 'WhatsApp Number', placeholder: '919981206128 (with country code, no +)' },
    ],
  },
  {
    title: 'Social Media',
    fields: [
      { key: 'facebook_url',  label: 'Facebook URL',  placeholder: 'https://facebook.com/...' },
      { key: 'instagram_url', label: 'Instagram URL', placeholder: 'https://instagram.com/...' },
      { key: 'twitter_url',   label: 'Twitter/X URL', placeholder: 'https://twitter.com/...' },
      { key: 'youtube_url',   label: 'YouTube URL',   placeholder: 'https://youtube.com/...' },
    ],
  },
  {
    title: 'SEO / Meta',
    fields: [
      { key: 'meta_title',       label: 'Meta Title',       placeholder: 'Heaven Green Infra. Landscape | Raipur' },
      { key: 'meta_description', label: 'Meta Description', placeholder: 'Premium landscaping services in Raipur...', textarea: true },
      { key: 'google_analytics', label: 'Google Analytics ID', placeholder: 'G-XXXXXXXXXX' },
    ],
  },
];

function AdminSettings() {
  const [form, setForm]     = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg]       = useState('');

  useEffect(() => {
    adminGetSettings().then(res => {
      if (res.success) setForm(prev => ({ ...prev, ...res.data }));
    }).finally(() => setLoading(false));
  }, []);

  const handleSave = async () => {
    setSaving(true);
    setMsg('');
    try {
      const res = await adminUpdateSettings(form);
      setMsg(res.success ? 'Settings saved successfully!' : 'Error: ' + res.message);
    } catch {
      setMsg('Network error');
    } finally {
      setSaving(false);
      setTimeout(() => setMsg(''), 4000);
    }
  };

  const f = (k, v) => setForm(p => ({ ...p, [k]: v }));

  if (loading) return <AdminLayout title="Settings"><div className="adm-loading">Loading settings…</div></AdminLayout>;

  return (
    <AdminLayout title="Settings">
      <div className="adm-page-header">
        <h2>Site Settings</h2>
        <button className="adm-btn-primary" onClick={handleSave} disabled={saving}>
          {saving ? 'Saving…' : 'Save All Settings'}
        </button>
      </div>

      {msg && (
        <div className={`adm-msg ${msg.startsWith('Settings') ? 'adm-msg--success' : 'adm-msg--error'}`}
          style={{ marginBottom: 20 }}>
          {msg}
        </div>
      )}

      {SECTIONS.map(section => (
        <div key={section.title} className="adm-card" style={{ marginBottom: 24 }}>
          <div className="adm-card__header">
            <h3>{section.title}</h3>
          </div>
          <div className="adm-card__body">
            {section.fields.map(field => (
              <div key={field.key} className="adm-form-field" style={{ marginBottom: 16 }}>
                <label>{field.label}</label>
                {field.textarea
                  ? <textarea
                      rows={3}
                      value={form[field.key] || ''}
                      onChange={e => f(field.key, e.target.value)}
                      placeholder={field.placeholder}
                      style={inputStyle}
                    />
                  : <input
                      type={field.type || 'text'}
                      value={form[field.key] || ''}
                      onChange={e => f(field.key, e.target.value)}
                      placeholder={field.placeholder}
                      style={inputStyle}
                    />
                }
              </div>
            ))}
          </div>
        </div>
      ))}

      <div style={{ textAlign: 'right', marginTop: 8 }}>
        <button className="adm-btn-primary" onClick={handleSave} disabled={saving}>
          {saving ? 'Saving…' : 'Save All Settings'}
        </button>
      </div>
    </AdminLayout>
  );
}

const inputStyle = {
    width: '100%',
    background: '#fafbfc',
    border: '1.5px solid #d1d5db',
    borderRadius: '8px',
    color: '#1a1547',
    padding: '0.6rem 0.85rem',
    fontSize: '0.9rem',
    outline: 'none',
    resize: 'vertical',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
    transition: 'all 0.2s',
};

export default AdminSettings;